import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';
import Moment from 'react-moment';
import {Table} from 'react-bootstrap';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import ModalData from '../patient/unitReserve/modalData';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import {ic_error_outline} from 'react-icons-kit/md/ic_error_outline';

const $ = require('jquery');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');
var report = require('../generics/report_head');

pdfMake.vfs = pdfFonts.pdfMake.vfs;

/*pdfMake.vfs['optim-Regular.ttf'] =  report.default.font;
pdfMake.vfs['optim-Medium.ttf'] =  report.default.font;
pdfMake.vfs['optim-Italic.ttf'] =  report.default.font;
pdfMake.fonts = {
	Roboto:{
		normal:'Roboto-Regular.ttf',
		bold:'Roboto-Medium.ttf',
		italics:'Roboto-Italic.ttf',
		bolditalics:'Roboto-MediumItalic.ttf'
	},
	Optim:{
		normal:'optim-Regular.ttf',
		bold:'optim-Medium.ttf',
		italics:'optim-Italic.ttf',
		bolditalics:'optim-Medium.ttf'
	}
}*/

class MessagesStatus extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.dateCompare = this.dateCompare.bind(this);
		this.viewDetails = this.viewDetails.bind(this);
		this.generatePDF = this.generatePDF.bind(this);
		this.generateExcel = this.generateExcel.bind(this);

		this.state = {
			start_date 	: "",
			end_date 	: "",

			listado:[],
			lista:[],

			columns:[
				{title: "Tipo Mensaje"},
				{title: "Referencia"},
				{title: "Fecha"},
				{title: "Estatus"},
				{title: "Ult. Intento de Envío"},
				{title: "Ver"},
			],
			health_facilities_id:"",
			filename:"Monitoreo de Mensajes",
		
			date_hour:"",
			medical:"",
			message:"all",
			messages:[],
			headers:"",
			status:"all",
			status_head:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			name:sessionStorage.getItem('health_facilities_name'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToImss){
			this.props.reload('hiddeToImss');
		}
	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		});

		fetch(Config.default.apiGateway.URL+'lookups/order_by?type=hl7_messagge&option=name',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => {
			if(response.ok){
				return response.json()
			}else{
				response.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		})
		.then(response => {
			if(response !== undefined){
				this.setState({
					messages:response
				});
			}
				
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'message'){
			this.setState({
				headers: e.target.value === 'all' ? 'TODOS' : e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'status'){
			this.setState({
				status_head: e.target.value === 'all' ? 'TODOS' : e.target.options[e.target.selectedIndex].text
			})
		}
	}

	generateExcel(){
		var obj = {
			start_date:this.state.start_date,
			health_facilities_id:sessionStorage.getItem('health_facilities_id'),
			end_date:this.state.end_date,
			option:this.state.message,
			status:this.state.status
		};
		
		obj.report_key = "monitoreo_mensajes";

		this.props.waiting.handleShow('Generando...');
		fetch(Config.default.apiGateway.URL+'reports/IMSS/generate_excel', {
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob',
			headers : new Headers({
				'Authorization': 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.props.fileDownload(this.state.filename, ".xlsx", 'application/vnd.ms-excel', response);
			}
		});
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){

				this.props.waiting.handleShow('Buscando...');

				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					option:this.state.message,
					status:this.state.status
				}
				fetch(Config.default.apiGateway.URL+'reports_imss/message_monitoring', {
					method : 'post',
					body:JSON.stringify(obj),
					headers : new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				})
				.then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				})
				.then(response => {
					if (response !== undefined) { 
						var list = [];
						response.map((res)=>{
							list.push([
								res.tyoe_mensaje,
								moment(res.date).format('DD/MM/YYYY HH:mm'),
								res.status,
								res.status !== 'ENVIADO' ?
									res.last_try !== null ? 
										moment(res.last_try).format('DD/MM/YYYY HH:mm')
									:''
								:'',
								res.reference,
								res.id
							])
						})

						this.setState({
							listado:response, 
							lista:list,
							headers: this.state.message === 'all' ? 'TODOS' : this.state.headers,
							status_head: this.state.status === 'all' ? 'TODOS' : this.state.status_head
						});
					}
						
				})
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	viewDetails(e, id,type, option){
		e.preventDefault();
		fetch(Config.default.apiGateway.URL+'hl7_imss/get_message?id='+id+'&type='+type, {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				if(option === 'mensaje'){
					this.modal_data.handleShow(response.mensaje, 'Detalle del mensaje');
				}else{
					if(response.error !== ""){
						this.modal_data.handleShow(response.error, 'Detalle del error');
					}
				}
				
			}
		})
		
	}

	generatePDF(){
		var body = [];
		var obj = [];
		var widths = ["30%", "30%","15%","10%","15%"];
		var fechas = "DEL "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" - "+moment(this.state.end_date).format("DD/MM/YYYY") 

		this.state.columns.map((c, i)=>{
			if(i < this.state.columns.length - 1){
				obj.push({text:c.title, style:'tableHeader', alignment:'left'});
			}
			
		});
		body.push(obj);

		this.state.listado.map((res, i)=>{
			var color = i%2=== 0 ? 'tableBodyOdd': '#fff';
			body.push([
				{text:res.type_message, style:color},
				{text:res.reference, style:color},
				{text:moment(res.date).format('DD/MM/YYYY HH:mm'), style:color},
				{text:res.status, style:color},
				res.status !== 'ENVIADO' ?
					res.last_try !== null ? 
						{text:moment(res.last_try).format('DD/MM/YYYY HH:mm'), style:color}
					:{text:'', style:color}
				:{text:'', style:color},
			])
		});

		var docDefinition = {
			//pageOrientation: 'landscape',
    		/*header: (currentPage, pageCount, pageSize)=>{
			    return [
			    	{table:{
			    		body:[
			    			[{
			    				image: this.props.header_document,
								alignment:'center',
								width:35,
								height: 27,
								rowSpan:3,
								margin:[0,0,-3,0]
			    			}, {}],
			    			[{},{text:'INSTITUTO MEXICANO DEL SEGURO SOCIAL', color:'#1f6157', fontSize:10, bold:1}],
			    			[{},{text:'INSTITUTO SEGURIDAD Y SOLIDARIDAD SOCIAL',color:'#1f6157', fontSize:4.9, margin:[0,-3,0,0]}]
			    		]
			    	}, margin:[175,5,0,0], layout:'noBorders'},
			    	{text:this.state.name,alignment:'center', fontSize:6},
			    	{text:fechas,alignment:'center', fontSize:7},
					{text:this.state.filename.toUpperCase(),alignment:'center', bold:1, fontSize:8},
					{text:[
						{text:'Tipo de Mensaje: '},
						{text:this.state.headers+'\t\t', bold:1},
						{text:'Estatus: '},
						{text:this.state.status_head, bold:1},
					], margin:[0,0,0,5], alignment:'center'}
			    ]
			},*/
			content:[
				{text:[
					{text:'Tipo de Mensaje: '},
					{text:this.state.headers+'\t\t', bold:1},
					{text:'Estatus: '},
					{text:this.state.status_head, bold:1},
				], margin:[0,0,0,5], alignment:'center'},
				{table:{
					body:body,
					widths:widths
				}, margin:[0,0,0,10],layout:"noBorders"}
			],
			footer:(currentPage, pageCount)=>{ 
    			return {
    				columns:[
    					{text:'Fecha de Impresión: '+this.state.date_hour, margin:[50,0,0,0]},
    					{ text: 'Página '+currentPage.toString() + ' de ' + pageCount, alignment: 'right', margin:[0,0,50,0] }
    				]
    			}; 
    		},
    		defaultStyle:{
    			fontSize: 6
    		},
    		styles:{
    			tableHeader:{
	    			fontSize: 6,
					bold:true
	    		},
	    		tableBodyOdd:{fillColor: "#f3f3f3"}
    		}
	    		
		};

		docDefinition.content.unshift({
			image: this.props.header_document,
			alignment:'center',
			width:this.props.w_head
		},{text:this.state.filename.toUpperCase(),alignment:'center', bold:1, fontSize:8},);

		docDefinition.content[0].table.widths=["30%", "30%","15%","10%","15%"];
		docDefinition.styles.tableHeader.fontSize = 6.5;
		docDefinition.defaultStyle.fontSize = 6.5; 
		docDefinition.styles.tableHeader.fillColor = this.props.base;


		pdfMake.createPdf(docDefinition).download(this.state.filename+'.pdf');
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{t('sidebar.nav.reports_imss.donors.message_status')}
					</h5>
				</div>

				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_message_monitoring"}  />
				
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12"><span>Campos Requeridos (*)</span></div>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="form-group">
									<div className="col-xs-12">
										<span className="span-min">Tipo de Mensaje</span>
										<select className="form-control" name="message" id="message" value={this.state.message}
											onChange={this.handleChange} required>
											<option value="all">TODOS</option>
											{this.state.messages.map((m, i)=>(
												<option key={i} value={m.key}>{m.name}</option>
											))}
										</select>
									</div>
								</div>
								<div className="form-group">
									<div className="col-xs-12">
										<span className="span-min">Estatus</span>
										<select className="form-control" name="status" id="status" value={this.state.status}
											onChange={this.handleChange} required>
											<option value="all">TODOS</option>
											<option value="ENVIADO">ENVIADO</option>
											<option value="PENDIENTE">PENDIENTE</option>
										</select>
									</div>
								</div>
								<div className="form-group">
									<div className="col-xs-12 col-sm-6 form-group">
										<span className="span-min">Fecha Desde</span><span> (*)</span>
										<input type="date" className="form-control hour-input" name="start_date" id="start_date"
											value={this.state.start_date} onChange={this.handleChange} required />
									</div>
									<div className="col-xs-12 col-sm-6 form-group">
										<span className="span-min">Fecha Hasta</span><span> (*)</span>
										<input type="date" className="form-control hour-input" name="end_date" id="end_date"
											value={this.state.end_date} onChange={this.handleChange} required />
									</div>
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",fontSize: "20px"}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12" style={{textAlign: "center",fontWeight: "bold",}}>
										<span>
											Del <Moment format="DD/MM/YYYY">{this.state.start_date}</Moment> - <Moment format="DD/MM/YYYY">{this.state.end_date}</Moment> 
										</span>
									</div>
								</div>
								<div className="col-xs-12 form-group">
									<div className="dt-buttons" style={{float:'right'}}> 
										<button className={this.state.listado.length === 0 ? "dt-button buttons-pdf buttons-html5 disabled" : "dt-button"} disabled={this.state.listado.length === 0} type="button"
											onClick={this.generateExcel}>
											<span>Excel</span>
										</button>
										<button className={this.state.listado.length === 0 ? "dt-button buttons-pdf buttons-html5 disabled" : "dt-button"} disabled={this.state.listado.length === 0} type="button"
											onClick={this.generatePDF}>
											<span>PDF</span>
										</button>
									</div>
								</div>

								<div className="col-xs-12 form-group"  style={{width:'100%', height:'40em', overflow:'auto'}}>
									{/*<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"table"} id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>*/}
									<Table responsive hover>
										<thead>
											<tr>
												{this.state.columns.map((col, i)=>(
													col.title === 'Ver' ?
														<th key={i} style={{paddingLeft:'4%'}}>{col.title}</th>
													: <th key={i}>{col.title}</th>
												))}
											</tr>
										</thead>
										<tbody>
											{this.state.listado.map((l, i)=>(
												<tr key={i}>
													<td>{l.type_message}</td>
													<td>{l.reference}</td>
													<td>{moment(l.date).format('DD/MM/YYYY HH:mm')}</td>
													<td>{l.status}</td>
													<td>
														{l.status !== 'ENVIADO' ?
															l.last_try !== null ? 
																moment(l.last_try).format('DD/MM/YYYY HH:mm')
															:null
														:null}
													</td>
													<td>
														<a href="#" className="btn" title="Ver Mensaje" 
															onClick={(e)=>this.viewDetails(e, l.id, l.type, 'mensaje')}>
															<SvgIcon icon={search} size={25} />
														</a>
														{l.status === 'PENDIENTE'?
															<a href="#" className="btn" title="Ver Error" style={{marginLeft:'5px'}}
																onClick={(e)=>this.viewDetails(e, l.id, l.type, 'error')}>
																<SvgIcon icon={ic_error_outline} size={25}/>
															</a>
														:null}
															
													</td>
												</tr>
											))}
										</tbody>
									</Table>
								</div>
							</div>
						</form>
					</div>
				</div>

				<ModalData {...this.props} onRef={ref => this.modal_data = ref} />
			</div>
		)
	}
}

export default translate('translations') (MessagesStatus);